/**
 * Cómo se llama cada paso del grafo y cada consulta, para una persona. Lo usan
 * el chat (`MensajeAsistente`) y las trazas: el mismo paso se llama igual en
 * las dos pantallas.
 */

/** `docs/grafo.md` de Patroclo. */
export const NOMBRES_NODO: Record<string, string> = {
  cargar_contexto: 'Cargar el contexto',
  enrutar: 'Decidir el camino',
  recuperar: 'Buscar en la base de conocimiento',
  responder_con_fuentes: 'Responder con las fuentes',
  agente_datos: 'Consultar ManejoAlcanza',
  verificar_cifras: 'Verificar que cada cifra salga de una consulta',
  responder_con_datos: 'Responder con los datos',
  rechazar: 'No responder',
  responder_saludo: 'Saludar',
  responder_ayuda: 'Explicar qué puedo hacer',
  guardar_historial: 'Guardar en el historial',
};

/** El nombre de cada consulta, como lo diría quien la pidió. */
export const NOMBRES_TOOL: Record<string, string> = {
  resumen_ordenes: 'Resumen de órdenes',
  detalle_orden: 'Expediente de una orden',
  ordenes_sin_factura: 'Órdenes sin factura',
  cartera: 'Cartera',
  otif: 'OTIF',
  cascada_pyg: 'Estado de resultados',
  inventario: 'Inventario',
};
